/**
 * Root Reducer
 */
import { folderReducer } from 'client/modules/Surveys/folderApiSlice';
import { linkReducer } from 'client/modules/Surveys/linkApiSlice';
import { surveyDriverReducer } from 'client/modules/Surveys/surveyDriverApiSlice';
import { combineReducers } from 'redux';
import app from './AppReducer';
import app2 from './modules/App/AppReducer';
import confirm from './modules/App/components/Confirm/ConfirmReducer';
import auth from './modules/Auth/AuthReducer';
import twoFactor from './modules/Auth/TwoFactorReducer';
import passkeys from './modules/Auth/PasskeyReducer';
import content from './modules/Content/ContentReducer';
import emailPreferences from './modules/EmailPreferences/EmailPreferencesReducer';
import { helpReducer } from './modules/Help/helpSlice';
import integrations from './modules/Integrations/IntegrationsReducer';
import pairwise from './modules/Pairwise/PairwiseReducer';
import { peopleReducer } from './modules/People/peopleApiSlice';
import people from './modules/People/PeopleReducer';
import pricing from './modules/Public/Pricing/PricingReducer';
import responses from './modules/Response/ResponseReducer';
import settings from './modules/Settings/SettingsReducer';
import sessions from './modules/Settings/SessionsReducer';
import subscriptions from './modules/Subscriptions/SubscriptionReducer';
import { apiKeyReducer } from './modules/Surveys/apiKeysSlice';
import { mcpOAuthReducer } from './modules/Settings/mcpOAuthSlice';
import { savedSearchesReducer } from './modules/Surveys/savedSearchApiSlice';
import { surveyAnalyzeReducer } from './modules/Surveys/surveyAnalyzeApiSlice';
import { surveyDeliveryReducer } from './modules/Surveys/surveyDeliveryApiSlice';
import surveys from './modules/Surveys/SurveyReducer';
import HubspotPropertiesReducer from './modules/Settings/HubspotPropertiesReducer';
import { SalesforcePropertiesReducer } from './modules/Settings/SalesforcePropertiesReducer';
// Combine all reducers into one root reducer
export default combineReducers({
  apiKeyReducer,
  mcpOAuthReducer,
  app,
  app2,
  auth,
  confirm,
  content,
  emailPreferences,
  folderReducer,
  integrations,
  helpReducer,
  linkReducer,
  pairwise,
  people,
  peopleReducer,
  pricing,
  responses,
  savedSearchesReducer,
  settings,
  sessions,
  subscriptions,
  surveyAnalyzeReducer,
  surveyDeliveryReducer,
  surveyDriverReducer,
  surveys,
  twoFactor,
  passkeys,
  hubspotProperties: HubspotPropertiesReducer,
  salesforceProperties: SalesforcePropertiesReducer,
});
